import { render, staticRenderFns } from "./CustomerSettings.vue?vue&type=template&id=09900986&scoped=true&"
import script from "./CustomerSettings.vue?vue&type=script&lang=ts&"
export * from "./CustomerSettings.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerSettings.vue?vue&type=style&index=0&id=09900986&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09900986",
  null
  
)

export default component.exports